/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import {
  Area,
  CartesianGrid,
  ComposedChart,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
// material
import { Card, Box, Paper, Typography } from '@mui/material';
//
import moment from 'moment';

// ----------------------------------------------------------------------
export function modelTooltip(fixTime, altitude, elevation, speed, uniteAltitude, uniteVitesse) {
  return (
    <Paper>
      <Typography style={{ marginLeft: 2, marginRight: 2, color: '#000000' }} variant="subtitle2">
        {`Heure: ${moment(fixTime).format('HH:mm:ss')}`}
      </Typography>
      <Typography style={{ marginLeft: 2, marginRight: 2, color: '#22398d' }} variant="subtitle2">
        {`Altitude: ${
          uniteAltitude === 'm' ? altitude.toFixed(0) : (altitude * 3.262).toFixed(0)
        } ${uniteAltitude}`}
      </Typography>
      {elevation !== undefined && (
        <Typography style={{ marginLeft: 2, marginRight: 2, color: '#c8ad7f' }} variant="subtitle2">
          {`Hauteur: ${
            // eslint-disable-next-line no-nested-ternary
            uniteAltitude === 'm'
              ? altitude - elevation > 0
                ? Math.abs(altitude - elevation).toFixed(0)
                : 0
              : altitude - elevation > 0
              ? (Math.abs(altitude - elevation) * 3.262).toFixed(0)
              : 0
          } ${uniteAltitude}`}
        </Typography>
      )}
      <Typography style={{ marginLeft: 2, marginRight: 2, color: '#e50e58' }} variant="subtitle2">
        {`Vitesse: ${
          uniteVitesse === 'km/h' ? (speed * 1.852).toFixed(0) : speed.toFixed(0)
        } ${uniteVitesse}`}
      </Typography>
    </Paper>
  );
}
CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array
};
function CustomTooltip({ active, payload, currentPosition, uniteAltitude, uniteVitesse }) {
  if (active && payload && payload.length) {
    return modelTooltip(
      payload[0].payload.fixTime,
      payload[0].payload.altitude,
      payload[0].payload.elevation,
      payload[0].payload.speed,
      uniteAltitude,
      uniteVitesse
    );
  }
  return modelTooltip(
    currentPosition.fixTime,
    currentPosition.altitude,
    currentPosition.elevation,
    currentPosition.speed,
    uniteAltitude,
    uniteVitesse
  );
}

// ----------------------------------------------------------------------
FlightReviewGraph.propTypes = {
  state: PropTypes.object,
  setState: PropTypes.func,
  indexDisplay: PropTypes.number
};

export default function FlightReviewGraph({ state, setState, indexDisplay }) {
  const { positions } = state;

  const CHART_DATA = positions.map((position) => ({
    ...position,
    fixTime: Number(moment(position.fixTime).format('x'))
  }));

  return (
    <Card sx={{ mr: 1 }}>
      <Box>
        <Paper sx={{ height: '28vh', width: '100%' }}>
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart
              data={CHART_DATA}
              onClick={(data) => {
                if (data !== undefined && data !== null && data.activeLabel !== undefined) {
                  setState({ ...state, currentPosition: data.activeTooltipIndex });
                }
              }}
            >
              <Tooltip
                wrapperStyle={{ visibility: 'visible' }}
                contentStyle={{}}
                content={
                  <CustomTooltip
                    currentPosition={
                      state.playVol ? positions[indexDisplay] : positions[state.currentPosition]
                    }
                    uniteAltitude={state.uniteAltitude}
                    uniteVitesse={state.uniteVitesse}
                  />
                }
                position={{ x: 5, y: 5 }}
              />

              <CartesianGrid stroke="#000000" />

              <XAxis
                dataKey="fixTime"
                allowDuplicatedCategory={false}
                tickFormatter={(timeStr) => moment(timeStr).format('HH:mm')}
                type="number"
                domain={['auto', 'auto']}
                scale="time"
                tick={false}
              />
              <YAxis
                type="number"
                domain={['dataMin', 'dataMax']}
                tick={false}
                orientation="left"
                yAxisId="alt"
              />
              <Line
                type="monotone"
                dataKey="altitude"
                name="altitude"
                key="altitude"
                stroke="#22398d"
                dot={false}
                activeDot={{ r: 5 }}
                strokeWidth={3}
                yAxisId="alt"
              />
              <Area
                type="monotone"
                dataKey="elevation"
                stroke="#c8ad7f"
                fill="#c8ad7f"
                dot={false}
                activeDot={{ r: 5 }}
                strokeWidth={3}
                yAxisId="alt"
              />
            </ComposedChart>
          </ResponsiveContainer>
        </Paper>
      </Box>
    </Card>
  );
}
